// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1rhXt","colMin":"styles_colMin__1o7JL","colCheckbox":"styles_colCheckbox__3231U"};